import authService from './authService';
import { ensureOk, readData, readList, toQuery } from './apiResponse';
import type { AppNotification, NotificationSummary } from '../types/planning';

class NotificationService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /notifications?unread_only= (até 50, não lidas primeiro) */
  async getAll(unreadOnly = false): Promise<AppNotification[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/notifications${toQuery({ unread_only: unreadOnly })}`);
    return readList<AppNotification>(response, 'Falha ao buscar os alertas');
  }

  /** GET /notifications/summary */
  async getSummary(): Promise<NotificationSummary> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/notifications/summary');
    const data = await readData<NotificationSummary>(response, 'Falha ao buscar o resumo dos alertas');
    return {
      unread: data?.unread ?? 0,
      overdue: data?.overdue ?? 0,
      due_today: data?.due_today ?? 0,
      critical: data?.critical ?? 0,
    };
  }

  /** PATCH /notifications/:id/read */
  async markRead(id: number): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.patch(`/notifications/${id}/read`);
    await ensureOk(response, 'Falha ao marcar o alerta como lido');
  }

  /** POST /notifications/read-all */
  async markAllRead(): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post('/notifications/read-all');
    await ensureOk(response, 'Falha ao marcar os alertas como lidos');
  }
}

export const notificationService = new NotificationService();
export default notificationService;
